import { arrayOf, string, oneOfType, number } from 'prop-types';

export const attribute = string;
export const attributes = arrayOf(string);

export const stringOrNumber = oneOfType([string, number]);
export const property = stringOrNumber;
export const properties = oneOfType([property, arrayOf(property)]);
